import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";


export default function UnmanagedLinuxVPS() {
 const [applyPaddingClass, setApplyPaddingClass] = useState(false);
 const billingBaseUrl = import.meta.env.VITE_BILLING_PORTAL_COM.startsWith('http') ? import.meta.env.VITE_BILLING_PORTAL_COM : `https://${import.meta.env.VITE_BILLING_PORTAL_COM}`;
  useEffect(() => {
    document.title = "Unmanaged Linux vps server | high perfomance"; 
        sal();
    }, []);
    const handlePlanClick = () => {
        ScrollToPlans(".price-plan-section");
        };
  return (
    <>
       <Helmet>
            <title>Unmanaged Linux vps server | high perfomance</title>
            <meta name="description" content="Get unmanaged Linux VPS hosting with full root access, SSD storage, high bandwidth, and total control-perfect for developers and advanced users." />
            <meta name="keywords" content="Unmanaged Linux VPS, Unmanaged-Linux-VPS-Hosting" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/unmanaged-linux-vps`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/unmanaged-linux-vps`} />
            <meta property="og:title" content="Unmanaged VPS Hosting: Ultimate Control & High-Performance" />
            <meta property="og:description" content="Get complete freedom with the help of Unmanaged VPS Hosting. Ideal for everyone, this solution offers complete server control & high performance under budget." />
       </Helmet>
       <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
        <div className="container">
            <div className="row g-4 align-items-center align-items-xxl-end">
                <div className="col-lg-7">
                    <div className="d-flex align-items-center gap-2">
                        <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                        <span className="d-block fw-semibold mb-0 text-primary">
                            You Control the Stack
                        </span>
                    </div>
                    <h1 className="mb-6 text-white">
                        Be the Boss with Our Unmanaged Linux VPS
                    </h1>
                    <p className="text-white max-text-60 mb-8 text-opacity-75">
                        Step into the driver’s seat and take full control! With our Unmanaged Linux VPS, you have all the freedom to personalize your server however you want to.
                    </p>
                    <div className="d-flex align-items-center flex-wrap gap-4">
                        <a href={`${billingBaseUrl}/index.php?rp=/login`} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded billing-login-url btn-height" >
                            <span className="btn-arrow__text">
                                Create Account
                                <span className="btn-arrow__icon">
                                <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </a>
                        <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                              <span className="btn-arrow__text">
                                  View Pricing
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </button>
                      <MinPlanPrice category="unmanaged-linux-vps" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 ipad-mt">
                    <div className="about-banner__img">
                        <img src="images/be-the-boss.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
      </div>
      <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-8">
                    <div className="text-center">
                      <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Real-World Use Cases</small>
                        <h2 className="ff-sg mb-0">From Server to E-Commerce: Uses for Unmanaged Linux VPS Hosting</h2>
                    </div>
                </div>
            </div>
            <div className="mt-12">
                <div className="row g-4">
                    <div className="col-xl-6">
                        <div className="bg-white p-7 rounded-3 h-100">
                            <div className="row align-items-center g-4">
                                <div className="col-xl-7">
                                    <h5 className="fs-20 mb-3">Launch Your Online Store</h5>
                                    <p className="mb-0">Want to launch your e-commerce store? Just install OpenCart, Magento, or PrestaShop with a 1-tap and start selling instantly! Your high-traffic-ready eCommerce website is only a click away.</p>
                                    <div className="pt-60">
                                        <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                                            <li className="d-flex align-items-center gap-2">
                                                <span className="fs-12"><i className="fa-solid fa-check"></i></span>
                                                <p className="fs-14 mb-0">Quick Brand Setup</p>
                                            </li>
                                            <li className="d-flex align-items-center gap-2">
                                                <span className="fs-12"><i className="fa-solid fa-check"></i></span>
                                                <p className="fs-14 mb-0">Secure Payments</p>
                                            </li>
                                            <li className="d-flex align-items-center gap-2">
                                                <span className="fs-12"><i className="fa-solid fa-check"></i></span>
                                                <p className="fs-14 mb-0">Scale Limitlessly</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-5">
                                    <img src="images/launch-your-online.webp" alt="Image" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3">
                        <div className="bg-white p-7 rounded-3 h-100">
                            <div className="d-flex flex-column justify-content-between gap-5 h-100">
                                <div className="text-center">
                                    <img src="images/run-multiple.webp" alt="Image" className="img-fluid" />
                                </div>
                                <div className="text-center">
                                    <h5 className="fs-18 mb-3">Run Multiple Websites</h5>
                                    <p className="fs-14 mb-0">Ready to host multiple sites? Our isolated environment makes sure that every website runs individually-no more downtime or delay, just seamless sailing all the way.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3">
                        <div className="bg-white p-7 rounded-3 h-100">
                            <div className="d-flex flex-column justify-content-between gap-5 h-100">
                                <div className="text-center">
                                    <h5 className="fs-18 mb-3">Quick Web & DB Setup</h5>
                                    <p className="fs-14 mb-0">Need a highly advanced database server? Set it up in very little time with your Unmanaged Linux VPS, and get to work without any struggle.</p>
                                </div>
                                <div className="text-center">
                                    <img src="images/quick-web.webp" alt="Image" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3">
                        <div className="bg-white p-7 rounded-3 h-100">
                            <div className="d-flex flex-column justify-content-between gap-5 h-100">
                                <div className="text-center">
                                    <h5 className="fs-18 mb-3">Manage Heavy Apps</h5>
                                    <p className="fs-14 mb-0">Ranging from apps to CRM, our VPS manages heavy tasks with ease, giving you the desired potential.</p>
                                </div>
                                <div className="text-center">
                                    <img src="images/manage-heavy.webp" alt="Image" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3">
                        <div className="bg-white p-7 rounded-3 h-100">
                            <div className="d-flex flex-column justify-content-between gap-5 h-100">
                                <div className="text-center">
                                    <img src="images/be-the-ceo.webp" alt="Image" className="img-fluid" />
                                </div>
                                <div className="text-center">
                                    <h5 className="fs-18 mb-3"> Be the CEO of Your Inbox</h5>
                                    <p className="fs-14 mb-0">Take full admin access to your whole ongoing communication! Effortlessly set up a completely managed email server with unlimited mailboxes, always keeping both your business and site visitors connected without any issue or confusion.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="bg-white p-7 rounded-3 h-100">
                            <div className="row align-items-center g-4">
                                <div className="col-xl-7">
                                    <h5 className="fs-20 mb-3">Test Your Stuff Anywhere</h5>
                                    <p className="mb-0">Launch test servers across the world to see how your site or application performs everywhere-no more suspense, just trustworthy outcomes.</p>
                                    <div className="pt-60">
                                        <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                                            <li className="d-flex align-items-center gap-2">
                                                <span className="fs-12"><i className="fa-solid fa-check"></i></span>
                                                <p className="fs-14 mb-0">Highly Reliable</p>
                                            </li>
                                            <li className="d-flex align-items-center gap-2">
                                                <span className="fs-12"><i className="fa-solid fa-check"></i></span>
                                                <p className="fs-14 mb-0">Deploy Anywhere</p>
                                            </li>
                                            <li className="d-flex align-items-center gap-2">
                                                <span className="fs-12"><i className="fa-solid fa-check"></i></span>
                                                <p className="fs-14 mb-0">No Location Limits</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-5">
                                    <img src="images/test-your-stuff.webp" alt="Image" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="price-plan-section pt-100 pb-100 position-relative">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> You Choose. We Support.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <PlanList category={'unmanaged-linux-vps'}/>
      </section>
      <div className="container pt-100 pb-100">
        <div className="row g-4">
            <div className="col-12">
                <div className="card border-0 roudned-4">
                    <div className="card-body pt-60 pb-60 px-md-15">
                        <div className="row g-4 align-items-center justify-content-between">
                            <div className="col-lg-4 sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <div className="cloud-hero__img">
                                    <img src="images/for-all-those-who.webp" alt="image" className="img-fluid" />
                                </div>
                            </div>
                            <div className="col-lg-8 col-xl-7">
                                <span className="d-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <span className="d-block w-2 h-2 rounded-circle bg-success"></span>
                                <span className="d-block text-white">
                      <span className="text-success fw-medium">Included Features</span>
                                </span>
                                </span>
                                <h2 className="h3 mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    For All Those Who Code, Not Just Click
                                </h2>
                                <p className="mb-8 max-text-56 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    If you are the one who loves to get under the hood, twist, and break, this Unmanaged Linux VPS is your online playground. Engineered for content creators and tech wizards who need zero restrictions.
                                </p>
                                <div className="row g-3">
                                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                        <div className="vstack gap-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            Full Admin Access
                          </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14"> Your Hosting, Your Choice </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            Terminal-First Freedom
                          </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            No More Restrictions
                          </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                        <div className="vstack gap-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            Freedom to Experiment
                          </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            Configure All Layers
                          </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            Build, Break, Rebuild
                          </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">
                            Raw infrastructure, True power
                          </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Link to="#" className="btn btn-success btn-arrow btn-arrow-lg btn-xl fs-14 fw-semibold rounded-pill mt-8 sal-animate open-live-chat btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <span className="btn-arrow__text">
                                    Talk To An Expert
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      <section className="bg-dark pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="w-2 h-2 rounded-circle bg-primary"></div>
                        <small className="text-primary fw-bold">What Sets Us Apart</small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">What You Get with All Unmanaged Linux VPS Plans</h2>
                        <p className="text-white mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"></p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Speed That Actually Hits Different</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/speed-that-actually.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Get that zoom-zoom vibe with blazing-fast SSDs and virtualization technology (like OpenVZ + KVM) that offers 3X quicker performance. Unlimited traffic? Yup, all this is yours.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Backup Game Powerful</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/backup-game.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Just chill! We've got your back. Automated snapshots for a week, along with a one-click on-demand snapshot. And if things don't go as expected, just ping us anytime.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Admin Made Easy</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/admin-made.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Launch unlimited accounts with optional cPanel/WHM or Plesk. Also, want to run WordPress like an expert? WordPress Toolkit is the main part of the party.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Scale With No Drama</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/scale-with.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Outgrowing your server? No worries. Unmanaged VPS Hosting helps you upgrade RAM, CPU, or storage whenever you want-no manual migrations, no tech stress.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Control Like a Boss</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/control-like.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Take complete access. With our unmanaged Linux VPS, twist everything from your operating system to your server layout-fully your unique vibe, your rules.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Real-Time Alerts, No Panic</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/real-time-alerts.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Get live insights into what’s happening-CPU, domains, RAM, storage-everything monitored with real-time alerts, so you’re never compromised with your privacy or anything else.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Data Centers That Slay</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">07</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/data-centres.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">Select amazing, fast, top-tier data centers from the United States, Europe, or Asia-Pacific. Quicker load times = happier website visitors = more lead generation.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h5 className="text-white mb-0">Locked Down and Loaded</h5>
                            <p className="h5 mb-0 text-white text-opacity-25">08</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="images/locked-down.webp" alt="icon" className="img-fluid" />
                            </div>
                            <div>
                                <p className="text-white mb-4">With our managed Linux VPS, you get 24/7 network monitoring, DDoS protection, a free SSL certificate for a whole year, and your very own dedicated IP. Security first, as always.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-100 pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Helping Our Clients = Our Priority.</span>
                                      <h4 className="mb-4">
                                          Lost in All Available Options? Relax.
                                      </h4>
                                      <p className="mb-6"> We are right here just for you. Let’s simplify it together. No Delay. No Glitch.</p>
                                      <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Start Hosting Now
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}
